import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Avatar,
  Button,
  Row,
  Col,
  Dropdown,
  Space,
  Modal,
  Drawer,
} from "antd";
import {
  PlusCircleOutlined,
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import { getEmployeeAPI } from "CommonComponents/Lookup/LookupAPI";
import { getLeadEmailsListAPI, deleteLeadEmailByIdAPI } from "../LeadsAPI";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import LeadEmailForm from "./LeadEmailForm";

const { Text } = Typography;

const LeadEmailItem = () => {
  const dispatch = useDispatch();
  const { leadId } = useParams();
  const intl = useIntl();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const leadEmailList = useSelector((state) => state.leads.leadEmailsList);
  const employeeList = useSelector((state) => state.lookup.employesList);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadEmails"
  )?.id;
  useEffect(() => {
    dispatch(getEmployeeAPI());
    dispatch(getLeadEmailsListAPI(leadId));
  }, [dispatch, leadId]);
  const getEmployeeNameById = (employeeId) => {
    const emp = employeeList?.find((e) => e?.id === employeeId);
    return emp ? `${emp.firstName} ${emp.lastName}` : "Unknown User";
  };
  const openDrawer = (email = null) => {
    setSelectedEmail(email);
    setDrawerVisible(true);
  };
  const closeDrawer = () => {
    setSelectedEmail(null);
    setDrawerVisible(false);
  };
  const handleDelete = (emailId) => {
    Modal.confirm({
      title: intl.formatMessage({ id: "LeadMail.DeleteConfirm" }),
      okText: intl.formatMessage({ id: "Common.Yes" }),
      cancelText: intl.formatMessage({ id: "Common.No" }),
      okType: "danger",
      onOk: () => dispatch(deleteLeadEmailByIdAPI(emailId, leadId)),
    });
  };
  const dropdownItems = (email) => [
    {
      key: "edit",
      label: (
        <span onClick={() => openDrawer(email)}>
          <EditOutlined /> <FormattedMessage id="Common.Edit" />
        </span>
      ),
    },
    {
      key: "delete",
      label: (
        <span onClick={() => handleDelete(email.id)}>
          <DeleteOutlined /> <FormattedMessage id="Common.Delete" />
        </span>
      ),
    },
  ];

  return (
    <>
      <Card
        size="small"
        title={<FormattedMessage id="LeadMail.Emails" />}
        extra={
          <Button type="link" onClick={() => openDrawer(null)}>
            <PlusCircleOutlined />
            <FormattedMessage id="LeadMail.AddNewMail" />
          </Button>
        }
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          {leadEmailList?.length > 0 ? (
            (() => {
              const email = leadEmailList[0];
              return (
                <Card key={email.id} className="activitytab">
                  <div className="activitytab-dropdown">
                    <Dropdown menu={{ items: dropdownItems(email) }}>
                      <Button icon={<MoreOutlined />} />
                    </Dropdown>
                  </div>
                  <Row gutter={12} align="middle">
                    <Col>
                      <Avatar size={36} icon={<UserOutlined />} />
                    </Col>
                    <Col flex="auto">
                      <Text strong>{getEmployeeNameById(email.createdBy)}</Text>
                      <br />
                      <Text type="secondary">
                        {dayjs(email.createdDate).format(
                          "DD MMM YYYY, hh:mm a"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <div style={{ marginTop: 8 }}>
                    <Text strong>{email.subject}</Text>
                    <p>{email.bodyOfMail}</p>
                  </div>
                  <AttachmentComponent
                    identifier={formTypeId}
                    currentId={email.id}
                    isPreview={true}
                    getattachments={true}
                  />
                </Card>
              );
            })()
          ) : (
            <Card>
              <Text type="secondary">
                <FormattedMessage id="NoData" />
              </Text>
            </Card>
          )}
        </Space>
      </Card>

      <LeadEmailForm
        email={selectedEmail}
        leadId={leadId}
        formTypeId={formTypeId}
        onClose={closeDrawer}
        drawerVisible={drawerVisible}
      />
    </>
  );
};

export default LeadEmailItem;
